import { getTenant, orgSearch } from '../helpers';
import { api } from './api';


export function getDetailedPathwayData(pathwayID, username, callback, isAssignedContent=false, platform=null) {
  const uuid = pathwayID;
  const searchParams = new URLSearchParams(window.location.search)
  const tenantToUse = searchParams.get('platform')
  const isUserRelatedPathway = searchParams.get('user_related')==="false"
  let data = {}
  if(isUserRelatedPathway){
    const realPathwayID = searchParams.get('pathway_id')
    getPathwayFromPersonalizedCatalog(username, realPathwayID, callback)
  }else{
     data = {
      pathway_uuid: uuid,
      platform_key: tenantToUse ?? getTenant(),
      ...(!isAssignedContent ? {
        username: username,
      } : {}),
    };
    api.ibldmpathway.getPathway(data, function(data) {
      callback(data);
    });
  }

}

export const getPathwayFromPersonalizedCatalog = async (username, pathwayRealID, callback) => {
  const params = new URLSearchParams({
    content:"pathways",
    pathway_id:pathwayRealID,
    return_items:"True"
  }).toString()
  const url = `${process.env.REACT_APP_IBL_DM_URL}/api/search/personalized-catalog/${username}/?${params}`
  await fetch(url, {
    method:"GET",
    headers: {
      'Authorization': `Token ${localStorage.getItem('dm_token')}`,
    }
  }).then((resp)=>{
    resp.json().then((data)=>{
      const results = Array.isArray(data?.results) ? data?.results : []
      const reArrangedPathwayData = []
      if(results.length > 0) {
        const pathwayData = results[0]
        const pathwayCourses = pathwayData?.items?.map((_item)=>({
          ..._item?.model
        }))
         reArrangedPathwayData.push({
           ...pathwayData,
           path:[...pathwayCourses]
         })
      }
      callback(reArrangedPathwayData)
    })
   })
}

export function pathwaySearchDataAPI(searchTerm, callback) {
  searchTerm = searchTerm.toLowerCase();
  if (searchTerm.length > 4) {
    const data =
      '?filter={"_index":"ibl-dm.public.dl_catalog_app_course"}&context=' +
      searchTerm;
    orgSearch(data, function(data) {
      callback(data?.results);
    });
  }
}

export function createPathway(data, callback) {
  api.ibldmpathway.createPathway(data, function(response) {
    callback(response);
  }, function(error) {
    console.error(error);
  });
}
